/* eslint-disable perfectionist/sort-imports */
import 'src/global.scss';

// ----------------------------------------------------------------------

import Router from 'src/routes/sections';

import { I18nProvider } from 'src/locales/i18n-provider';
import ThemeProvider from 'src/theme';
import { Snackbar, SnackbarProvider } from 'src/components/snackbar';
import { AuthProvider } from 'src/auth/context';
import LocalizationProvider from './components/locales/localization-provider';

import { ConfirmDialogProvider } from './context/ConfirmDialogProvider';
import { ToastProvider } from './context/ToastProvider';
import { LoadingProvider } from './context/LoadingProvider';
import { ProvinceProvider } from './context/ProvinceProvider';
import { ConfirmInputDialogProvider } from './context/ConfirmInputDialogProvider';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <I18nProvider>
      <LocalizationProvider>
        <ToastProvider>
          <AuthProvider>
            <ProvinceProvider>
              <ConfirmInputDialogProvider>
                <ConfirmDialogProvider>
                  <ThemeProvider>
                    <LoadingProvider>
                      <SnackbarProvider>
                        <Snackbar />
                        <Router />
                      </SnackbarProvider>
                    </LoadingProvider>
                  </ThemeProvider>
                </ConfirmDialogProvider>
              </ConfirmInputDialogProvider>
            </ProvinceProvider>
          </AuthProvider>
        </ToastProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
